export const FLAVOR_CANCEL = 'cancel';
export const FLAVOR_CONFIRMATION = 'confirmation';
export const FLAVOR_CTA = 'cta';
export const FLAVOR_DEFAULT = 'default';
export const FLAVOR_INTERACTION = 'interaction';

export const FLAVORS = [
    FLAVOR_CANCEL,
    FLAVOR_CONFIRMATION,
    FLAVOR_CTA,
    FLAVOR_DEFAULT,
    FLAVOR_INTERACTION
];
